import ComparisonCarousel from '../components/comparison-carousel';
import { docReady } from '../utils/docReady';
console.log('Comparison Carousel');
// We had to remove the register functionality from slate as it causes conflicts with sections anywhere.
docReady(() => {
    const sections = document.querySelectorAll('[data-section-type="comparison-carousel"]');
    if (sections.length > 0) {
        [...sections].forEach((section) => {
            const { desktopCount, mobileCount, sectionId } = section.dataset;
            const slides = parseInt(section.dataset.tiles, 10);
            console.log(section, slides);
            if (slides > 1) {
                const carousel = new ComparisonCarousel(section, slides, Number(desktopCount), Number(mobileCount));
            }
        });
    }
});
